import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsPermissionsRoute: InvariantJiraRoute = {
	name: 'arj-settings-permissions',
	path: '/jira/plans/settings/permissions',
};
